export enum CommunicationInterfaceType {
    WiredIP = 0,
    MobileData = 1,
    WirelessIP = 18,
    Sms = 20,
}
